import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { FiBriefcase, FiMapPin, FiCalendar } from 'react-icons/fi';
import './Experience.css';

const Experience = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const experiences = [
    {
      title: 'Director of Engineering',
      company: 'Outcode Software',
      location: 'Nepal',
      period: 'Present',
      description: [
        'Leading engineering teams to deliver high-quality software solutions',
        'Driving technical strategy and architecture decisions',
        'Building and scaling high-performance engineering teams',
        'Establishing engineering best practices and processes',
      ],
      current: true,
    },
    {
      title: 'Engineering & Product Leader',
      company: 'Various Organizations',
      location: 'Nepal',
      period: 'Earlier',
      description: [
        'Built and shipped multiple successful products',
        'Led teams through complex technical challenges',
        'Mentored junior engineers and fostered growth',
        'Contributed to architectural decisions and technical roadmaps',
      ],
      current: false,
    },
  ];

  return (
    <section id="experience" className="experience section" ref={ref}>
      <div className="container">
        <motion.div
          className="experience-header"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Experience</h2>
          <p className="section-subtitle">
            My professional journey in engineering leadership
          </p>
        </motion.div>

        <div className="timeline">
          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              className={`timeline-item ${exp.current ? 'current' : ''}`}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <div className="timeline-marker">
                <div className="marker-dot"></div>
              </div>
              <motion.div
                className="timeline-content card"
                whileHover={{ scale: 1.02 }}
              >
                <div className="timeline-header">
                  <div>
                    <h3 className="timeline-title">{exp.title}</h3>
                    <div className="timeline-company">
                      <FiBriefcase />
                      {exp.company}
                    </div>
                  </div>
                  {exp.current && <span className="current-badge">Current</span>}
                </div>
                <div className="timeline-meta">
                  <span>
                    <FiMapPin />
                    {exp.location}
                  </span>
                  <span>
                    <FiCalendar />
                    {exp.period}
                  </span>
                </div>
                <ul className="timeline-description">
                  {exp.description.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
